import { Component } from '@angular/core';
import {Title} from "@angular/platform-browser";
import {environment} from "../environments/environment";

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent {
  constructor(private titleService: Title) {
    const environmentVersion = environment.version;

    switch (environmentVersion) {
      case "local":
        this.titleService.setTitle("LOCAL | Explect | Track & Trace");
        break;
      case "dev":
        this.titleService.setTitle("DEV | Explect | Track & Trace");
        break;
      case "test":
        this.titleService.setTitle("TEST | Explect | Track & Trace");
        break;
      case "prod":
        this.titleService.setTitle("Explect | Track & Trace");
    }
  }
}
